import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import {
  getPerformanceAddedPropertiesMiniCard,
  getPerformanceConcretedOperationsMiniCard,
  getPerformanceConversionRateMiniCard,
  getPerformanceConversionTimeMiniCard,
  getPerformanceDoneEventsMiniCard,
  getPerformanceNewContactsMiniCard,
  getPerformanceReceivedLeadsMiniCard,
  getPerformanceResponseTimeMiniCard,
} from '@/store/slices/components/dashboard/service';

export const KPI_TEXTS = {
  inquiriesReceived: {
    title: Trans(translations, 'InquiriesReceived'),
    tooltip: Trans(translations, 'InquiriesReceivedInTheSelectedDateRange'),
  },
  conversionRate: {
    title: Trans(translations, 'ConversionRate'),
    tooltip: Trans(
      translations,
      'ConversionRateForContactsCreatedInThisPeriod'
    ),
  },
  doneVisits: {
    title: Trans(translations, 'VisitsMade'),
    tooltip: Trans(translations, 'VisitsMadeWithinTheSelectedDateRange'),
  },
  responseTime: {
    title: Trans(translations, 'ResponseTime'),
    tooltip: Trans(translations, 'AverageTimeOfAgentFirstResponse'),
  },
  conversionTime: {
    title: Trans(translations, 'ConversionTime'),
    tooltip: Trans(
      translations,
      'AverageTimeFromLeadAssignmentToAConcretedOperation'
    ),
  },
  newContacts: {
    title: Trans(translations, 'NewContacts'),
    tooltip: Trans(
      translations,
      'ContactsThatWereCreatedInTheSelectedDateRange'
    ),
  },
  addedProperties: {
    title: Trans(translations, 'AddedProperties'),
    tooltip: Trans(
      translations,
      'PropertiesTurnedAvailableInTheSelectedDateRange'
    ),
  },
  concretedOperations: {
    title: Trans(translations, 'ConcretedOperations'),
    tooltip: Trans(translations, 'ConcretedOperationsInTheSelectedDateRange'),
  },
};

export const KPI_CALLBACKS = {
  inquiriesReceived: (dispatch, query) =>
    dispatch(getPerformanceReceivedLeadsMiniCard({ query })),
  conversionRate: (dispatch, query) =>
    dispatch(getPerformanceConversionRateMiniCard({ query })),
  doneVisits: (dispatch, query) =>
    dispatch(getPerformanceDoneEventsMiniCard({ query })),
  responseTime: (dispatch, query) =>
    dispatch(getPerformanceResponseTimeMiniCard({ query })),
  conversionTime: (dispatch, query) =>
    dispatch(getPerformanceConversionTimeMiniCard({ query })),
  newContacts: (dispatch, query) =>
    dispatch(getPerformanceNewContactsMiniCard({ query })),
  addedProperties: (dispatch, query) =>
    dispatch(getPerformanceAddedPropertiesMiniCard({ query })),
  concretedOperations: (dispatch, query) =>
    dispatch(getPerformanceConcretedOperationsMiniCard({ query })),
};

export const KPI_CARD_PROPS = {
  InquiriesReceived: {
    kpiId: 'inquiriesReceived',
    trackKey: 'inquiriesReceived',
  },
  NewContacts: {
    kpiId: 'newContacts',
    trackKey: 'newContacts',
  },
  ResponseTime: {
    kpiId: 'responseTime',
    trackKey: 'responseTime',
  },
  VisitsMade: {
    kpiId: 'doneVisits',
    trackKey: 'visitsMade',
  },
  ConversionRate: {
    kpiId: 'conversionRate',
    trackKey: 'conversionRate',
  },
  ConversionTime: {
    kpiId: 'conversionTime',
    trackKey: 'conversionTime',
  },
  AddedProperties: {
    kpiId: 'addedProperties',
    trackKey: 'addedProperties',
  },
  ConcretedOperations: {
    kpiId: 'concretedOperations',
    trackKey: 'concretedOperations',
  },
};
